/**
 * Make generated Ziggy routes follow the domain currently serving the app.
 * Route metadata is build-time data, but its host must be runtime data.
 */
export function withRuntimeOrigin(ziggy) {
    if (typeof window === 'undefined' || !window.location) return ziggy;

    return {
        ...ziggy,
        url: window.location.origin,
        port: window.location.port || null,
    };
}

/** Resolve a relative site asset against the domain currently serving the app. */
export function absoluteRuntimeUrl(value, fallback = '/') {
    const source = String(value || fallback).trim() || fallback;
    if (typeof window === 'undefined' || !window.location) return source;

    try {
        return new URL(source, window.location.origin).href;
    } catch (_) {
        return new URL(fallback, window.location.origin).href;
    }
}
